export default __webpack_public_path__ + "8726e09.png";